<script setup lang="ts">
import { computed } from "vue"
import KilatesTheme from './themes/KilatesTheme.vue'
import DefaultTheme from './themes/DefaultTheme.vue'

const props = defineProps<{ 
  metal?: string, 
  configId?: string, 
  theme?: string 
}>()

const activeMetal = computed(() => props.metal || 'xau')
const activeConfigId = computed(() => props.configId || 'default')

const currentThemeComponent = computed(() => {
  if (props.theme === 'kilates') {
    return KilatesTheme
  }
  return DefaultTheme
})
</script>

<template>
  <component 
    :is="currentThemeComponent" 
    :metal="activeMetal" 
    :configId="activeConfigId" 
  />
</template>
